import { useSignoutUser } from "@/hooks/useSignoutUser";

export const SignoutUser = () => {
  useSignoutUser();

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{ marginTop: "-3.5rem" }}
    >
      <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
        {/* Maring left due to the image containing a load of spacing to the right */}
        <img
          src="/images/dragonflyai-logo.svg"
          height="42"
          alt="Dragonfly"
          style={{ marginLeft: "153px" }}
        />
        <p className="lead mt-2">Please wait...</p>
      </div>
    </div>
  );
};
